import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SwalService } from 'src/app/services/utls/swal.service';
import { RecoverPassModel } from 'src/app/models/recover.model';

@Component({
  selector: 'app-recover-pass',
  templateUrl: './recover-pass.component.html',
  styleUrls: ['./recover-pass.component.scss'],
})
export class RecoverPassComponent implements OnInit {
  recoverPass: RxFormGroup;
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  isLogin: boolean = false;
  code: string = '';

  constructor(
    private router: Router,
    private routeParams: ActivatedRoute,
    private fb: RxFormBuilder,
    private authService: AuthService,
    public swalService: SwalService
  ) {}

  getErrorMessage(controlName: string): string {
    const control = this.recoverPass.get(controlName);
    if (control?.errors) {
      const firstError = Object.keys(control.errors)[0];
      return control.errors[firstError]?.message || '';
    }
    return '';
  }

  async ngOnInit(): Promise<void> {
    this.code = this.routeParams.snapshot.paramMap.get('code');
    await this.initForm();
    await this.validateTokenExpiration();
    this.isLogin = true;
  }

  arePasswordFieldsEmpty(): boolean {
    const password = this.recoverPass.get('password')?.value;
    const confirmPassword = this.recoverPass.get('confirmPassword')?.value;
    return !password || !confirmPassword;
  }

  async validateTokenExpiration() {
    this.authService.validateTokenExpiration(this.code).subscribe({
      next: async (response) => {
        this.isLogin = false;
        if (
          response?.valid_token == 'Token expirado' ||
          response?.status == 220
        ) {
          this.swalService
            .info(
              'Token expirado',
              'Por favor, inicia nuevamente el proceso para cambiar tu contraseña.'
            )
            .then(() => {
              this.router.navigate(['/login']);
            });
        }
      },
      error: (error) => {
        console.error('Login failed', error);
      },
    });
  }

  async initForm(): Promise<void> {
    return new Promise((resolve) => {
      const recover = new RecoverPassModel();
      this.recoverPass = this.fb.formGroup(recover) as RxFormGroup;

      // Opcional: Para depuración, puedes ver los cambios del formulario
      this.recoverPass.valueChanges.subscribe(() => {
      });

      resolve();
    });
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  recoverPassword() {
    if (!this.recoverPass.valid) {
      console.warn('Formulario inválido, no se ejecuta la acción');
      return;
    }
    this.isLogin = true;

    const { password } = this.recoverPass.value;
    this.authService.changePassword(password, this.code).subscribe({
      next: async (response) => {
        if (response.code == 200) {
          this.isLogin = false;
          this.swalService
            .success(
              '¡Genial!',
              'Tu contraseña ha sido restablecida con éxito, ya puedes iniciar sesión nuevamente.'
            )
            .then(() => {
              this.router.navigate(['/home']);
            });
        }
      },
      error: (error) => {
        this.isLogin = false;
        console.error('Error al cambiar la contraseña', error);
      },
    });
  }

  navigateToLogin() {
    this.router.navigate(['/home']);
  }
}
